import { theme } from '@features/executive-report/domain/theme';
import { ShapeProps } from '@features/powerpoint';

export const driverShapes = (
  index: number,
  driverOffset: number
): ShapeProps[] => [
  {
    shapeName: 'rect',
    options: {
      h: 1.28,
      w: 4.44,
      x: 8.51,
      y: 3.07 + driverOffset * index,
      fill: {
        color: theme.colors.black,
        transparency: 25,
      },
    },
  },
  {
    shapeName: 'line',
    options: {
      h: 0,
      w: 2.03,
      x: 10.72,
      y: 3.42 + driverOffset * index,
      line: {
        color: theme.colors.inmarketGreen,
        width: 1,
      },
    },
  },
];
